// components/SectionHeading.jsx
import React from "react";
import styles from "../Info.module.css";

const SectionHeading = ({ badge, badgeColor = "purple", title, subtitle }) => {
  return (
    <div className={styles.sectionHeading}>
      {badge && (
        <span
          className={`${styles.sectionBadge} ${
            badgeColor === "gold"
              ? styles.sectionBadgeGold
              : badgeColor === "teal"
                ? styles.sectionBadgeTeal
                : ""
          }`}
        >
          {badge}
        </span>
      )}
      <h2 className={styles.sectionTitle}>{title}</h2>
      {subtitle && <p className={styles.sectionSubtitle}>{subtitle}</p>}
    </div>
  );
};

export default SectionHeading;